import React from "react";
import { Container, Typography, Box } from "@mui/material";

const PrivacyPolicy = ({ isModal = false }) => {
  return (
    <Container 
      maxWidth={isModal ? false : "md"} 
      disableGutters={isModal}
      sx={{ py: isModal ? 0 : 4, px: isModal ? 0 : undefined }}
    >
      {!isModal && (
        <Typography
          variant="h3"
          component="h1"
          align="center"
          gutterBottom
          sx={{ fontWeight: 100, mt: 25, mb: 10 }}
        >
          Privacy Policy
        </Typography>
      )}

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          Privacy Statement
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?
        </Typography>
        <Typography color="text.secondary">
          When you purchase something from our store, we collect personal
          information such as your name, address and email address. We also
          receive your IP address automatically when you browse, which helps us
          learn about your browser and OS. With your permission, we may send you
          emails about our store, new products, and updates.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          SECTION 2 - CONSENT
        </Typography>
        <Typography color="text.secondary">
          When you provide information to complete a transaction, we imply your
          consent for that purpose only. If we ask for your personal info for
          marketing, we will ask you directly or give you the option to decline.
          To withdraw consent, contact: contact@dainasoul.com
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          SECTION 3 - DISCLOSURE
        </Typography>
        <Typography color="text.secondary">
          We may disclose your info if required by law or if you violate our
          Terms of Service.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          SECTION 4 - SHOPIFY
        </Typography>
        <Typography color="text.secondary">
          Our store is hosted on Shopify Inc. They store your data securely
          behind a firewall. If you use a direct payment gateway, Shopify stores
          your credit card data encrypted via PCI-DSS. Purchase info is only
          stored as long as needed. For more details, read Shopify’s Terms of
          Service and Privacy Policy.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          SECTION 5 - THIRD-PARTY SERVICES
        </Typography>
        <Typography color="text.secondary">
          Third-party providers collect/use your info only as necessary.
          However, their own privacy policies apply, especially payment
          gateways. Your data may be subject to different laws depending on
          where third parties are located (e.g., U.S. Patriot Act). Links from
          our site may redirect to third-party sites. We are not responsible for
          their privacy practices.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          SECTION 6 - SECURITY
        </Typography>
        <Typography color="text.secondary">
          We follow industry best practices and PCI-DSS standards. Card info is
          encrypted using SSL and AES-256. While no method is 100% secure, we
          take reasonable precautions to protect your data.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          SECTION 7 - COOKIES
        </Typography>
        <Typography color="text.secondary">
          We use cookies including:
          <br />• _session_id - sessional
          <br />• _shopify_visit - stats, 30 min
          <br />• _shopify_uniq - daily visit counter
          <br />• cart - 2 weeks
          <br />• _secure_session_id, storefront_digest
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          SECTION 8 - AGE OF CONSENT
        </Typography>
        <Typography color="text.secondary">
          By using this site, you confirm you are at least the age of majority
          in your area, or have consented for a minor dependent to use the site.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          SECTION 9 - CHANGES TO THIS PRIVACY POLICY
        </Typography>
        <Typography color="text.secondary">
          We may modify this policy anytime. Updates take effect immediately
          upon posting. If we are acquired or merge, your info may be
          transferred.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
          QUESTIONS AND CONTACT INFORMATION
        </Typography>
        <Typography color="text.secondary">
          For questions or to access, correct, amend or delete your data,
          contact: contact@dainasoul.com.
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
